<template>
  <form class="form" @submit.prevent="createStudents">
    <h2>{{ $t('newStudents.TITLE') }}</h2>
    <label>{{ $t('newStudents.label.EXAM') }}</label>
    <select-exam
      v-model="selectedExam"
      :options="exams"/>
    <file-upload-button
      class="file-upload-container"
      v-model="studentsFile"
      :buttonText="$t('newStudents.UPLOAD_BUTTON')"
      :helpText="$t('newStudents.UPLOAD_HELP')"/>
    <div v-if="errors.length" class="errors-container">
      <ul>
        <li class="error" v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="submit-container">
      <input class="primary-button" type="submit" :value="$t('newStudents.SUBMIT_BUTTON')">
    </div>
  </form>
</template>

<script>
import SelectExam from '@/components/SelectExam'
import FileUploadButton from '@/components/FileUploadButton'
import { mapActions } from 'vuex'
import { xlsxToJSON, saveJSONAsXLSX, makeSessionLinks } from '@/utils/utils.format'

export default {
  name: 'NewStudents',
  components: {
    SelectExam,
    FileUploadButton
  },
  data () {
    return {
      selectedExam: null,
      exams: [],
      studentsFile: null,
      errors: [],
    }
  },
  created () {
    this.$loading.start()

    this.fetchExams()
      .then((exams) => {
        this.exams = exams
      })
      .catch(() => this.$loading.fail())
      .finally(() => this.$loading.done())
  },
  methods: {
    checkForm () {
      this.errors = []

      if (!this.selectedExam) {
        this.errors.push(this.$t('newStudents.error.EXAM_REQUIRED'))
      }

      if (!this.studentsFile) {
        this.errors.push(this.$t('newStudents.error.STUDENTS_REQUIRED'))
      }

      return !this.errors.length
    },
    clearForm () {
      this.selectedExam = null
      this.studentsFile = null
    },
    createStudents () {
      const formValid = this.checkForm()

      if (formValid) {
        this.sendStudents()
      }
    },
    sendStudents () {
      xlsxToJSON(this.studentsFile)
        .then(this._sendStudents)
        .catch(() => this.$awn.alert(this.$t('newStudents.awn.PROCESSING_FAILURE')))
    },
    _sendStudents (students) {
      students.forEach(student => {
        student.exam = this.selectedExam.id
      })

      const uploadStudentsPromise = this.uploadStudents({ examId: this.selectedExam.id, students })
        .finally(() => this.clearForm())

      this.$awn.async(
        uploadStudentsPromise,
        this.onUploadSuccess,
        this.onUploadFailure,
        this.$t('newStudents.awn.SEND_FORM')
      )
    },
    makeSessionLinksFile (sessionLinks) {
      const links = makeSessionLinks(sessionLinks)
      const name = 'sessions'

      saveJSONAsXLSX(links, name)
    },
    onUploadSuccess (students) {
      this.$awn.success(this.$t('newStudents.awn.UPLOAD_SUCCESS'))

      try {
        this.makeSessionLinksFile(students)
      } catch (e) {
        this.$awn.alert(this.$t('newStudents.awn.LINKS_FAILURE'))
      }
    },
    onUploadFailure () {
      this.$awn.alert(this.$t('newStudents.awn.UPLOAD_FAILURE'))
    },
    ...mapActions(['fetchExams', 'uploadStudents'])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/base.scss';

.result-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

</style>
